import { Table as AntdTable, type TableProps as AntdTableProps } from 'antd'
import React from 'react'

import {
  type Column,
  formatTableColumns,
  formatTableRows,
  type TableRow
} from './utils'

export type TableColumnProp = Column

type TableProps<RecordType = object> = {
  /**
   * The columns for the table.
   */
  columns: Column<RecordType>[]
  containerClass?: string
  /**
   * Class name for the container div. Allows custom stylings to be passed down.
   */
  rowClassName?: string
  /**
   * Function that fires when pagination, filters or sorter is changed.
   */
  onChange?: AntdTableProps<RecordType>['onChange']
  /**
   * The rows for the table.
   *
   * There are places in code, where rows can be undefined. Rows should pe a required field
   */
  rows: TableRow[]
  /**
   * Toggles whether or not to have pagination for the table.
   *
   * @default false
   */
  pagination?: AntdTableProps<RecordType>['pagination']
  /**
   * The config for scrolling. See the AntD page for more details.
   */
  scroll?: AntdTableProps<RecordType>['scroll']
  onRow?: (record?: unknown, rowIndex?: number) => unknown
  loading?: boolean
  size?: 'middle' | 'large' | 'small'
}

/**
 * @deprecated
 */
// eslint-disable-next-line camelcase
export default function TableOLD<RecordType extends TableRow = TableRow>({
  columns,
  containerClass,
  rowClassName,
  onChange,
  pagination = false,
  rows,
  scroll,
  onRow,
  loading,
  size
}: TableProps<RecordType>) {
  return (
    <div className={containerClass}>
      <AntdTable
        // @ts-ignore
        columns={formatTableColumns(columns)}
        // @ts-ignore
        dataSource={formatTableRows(columns, rows)}
        // @ts-ignore
        onChange={onChange}
        pagination={pagination}
        scroll={scroll}
        loading={loading}
        size={size}
        rowClassName={rowClassName}
        // @ts-ignore
        onRow={onRow}
      />
    </div>
  )
}
